import React, { forwardRef } from 'react';

// South African Rand "R" currency icon, drop-in replacement for lucide's
// DollarSign: same 24x24 stroke-based glyph contract, so size/color are
// driven by className (w-* h-*, text-*) exactly like any lucide icon.
const RandSign = forwardRef(({ size = 24, ...props }, ref) => (
  <svg
    ref={ref}
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M8 20V4h5a4 4 0 0 1 0 8H8" />
    <path d="m13 12 4 8" />
  </svg>
));

RandSign.displayName = 'RandSign';

export default RandSign;
